/*
 * - Definitions of Dashboard mutations
 */

import { toast } from 'react-toastify';
import DashboardService from './service';
import {
  CancelDashboardRequest,
  CancelDashboardRequestResponse,
  WithdrawDashboardRequest,
  WithdrawDashboardRequestResponse,
} from './types';
import { ResponseStatuses } from '@src/utils/enums';
import { tSuccess } from '@src/utils/toast-helpers';
import { queryClient } from '@src/api/queryClient';
import { DASHBOARD_QUERY_KEYS } from './query';

export class DashboardMutations {
  public static readonly cancelRequest = async (
    payload: CancelDashboardRequest
  ): Promise<CancelDashboardRequestResponse> => {
    const toastId = toast.loading('Cancelling Request...');
    const { projectId, requestId, version } = payload;
    const response = await DashboardService.cancelRequest(projectId, requestId, version);

    if (response.status === ResponseStatuses.Success) {
      tSuccess(toastId, 'Request successfully cancelled');
      queryClient.invalidateQueries({ queryKey: [DASHBOARD_QUERY_KEYS.GET_DASHBOARD] });
      return response;
    } else {
      toast.dismiss(toastId);
      return Promise.reject(response.msg || 'Draft request cancellation failed');
    }
  };

  public static readonly withdrawRequest = async (
    payload: WithdrawDashboardRequest
  ): Promise<WithdrawDashboardRequestResponse> => {
    const toastId = toast.loading('Withdrawing Request...');
    const { projectId, requestId, version } = payload;
    const response = await DashboardService.withdrawRequest(projectId, requestId, version);

    if (response.status === ResponseStatuses.Success) {
      tSuccess(toastId, 'Request successfully withdrawn');
      queryClient.invalidateQueries({ queryKey: [DASHBOARD_QUERY_KEYS.GET_DASHBOARD] });
      return response;
    } else {
      toast.dismiss(toastId);
      return Promise.reject(response.msg || 'Withdraw submitted request failed');
    }
  };
}
